import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { InfluencerContext } from '../../../../../contexts/InfluencerContext'
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext'
import { SharedInfluencerContext } from '../../../../../contexts/Advertiser/SharedInfluencerContext'
import Authentication from '../../../../../models/Authentication'
import Post from '../../../Shared/Post'
import axiosService from '../../../../../utils/AxiosService'
import { toastError } from '../../../../../components/FormComponents/Toasts'

export default observer(function Posts() {
  const params = useParams()
  const { id, authentication_id, campaign_authentication_id, uuid } = params
  const navigate = useNavigate()
  const influencerContext = useContext(InfluencerContext)
  const sharedCampaignContext = useContext(SharedCampaignContext)
  const sharedInfluencerContext = useContext(SharedInfluencerContext)
  const [authentications, setAuthentications] = useState([])

  const isAdvertiserContext = !!sharedCampaignContext?.campaignState
  const isInfluencerShareContext = !!sharedInfluencerContext?.influencerState
  const currentId = isInfluencerShareContext
    ? (sharedInfluencerContext?.authentications?.[0]?.id)
    : (isAdvertiserContext ? authentication_id : id)

  useEffect(() => {
    if (isAdvertiserContext && authentication_id) {
      axiosService.get(`/api/advertiser/campaign_share/authentications/${authentication_id}/authentications`)
        .then(authentications => {
          const mappedAuthentications = authentications.map(authentication => new Authentication(authentication))
          setAuthentications(mappedAuthentications)
        })
        .catch((error) => {
          const errorMessage = error?.response?.data?.error || error?.data?.error || error?.error || error?.message || 'An error occurred'
          toastError(errorMessage)
        })
    }
  }, [isAdvertiserContext, authentication_id])

  const pmAuthentications = influencerContext?.authentications || []
  const sharedInfluencerAuthentications = sharedInfluencerContext?.authentications || []
  const currentAuthentications = isInfluencerShareContext
    ? sharedInfluencerAuthentications
    : (isAdvertiserContext ? authentications : pmAuthentications)

  const currentAuthentication = useMemo(() => currentAuthentications.find(authentication => +authentication.id === +currentId ) || new Authentication(), [currentId, currentAuthentications, currentAuthentications.length] )
  const posts = useMemo(() => currentAuthentication.posts?.filter(post => post.post_type === 'image').slice(0, 4) || [], [currentAuthentication, currentAuthentication.posts, currentAuthentication.posts?.length])

  const handleGoToSocialPosts = () => {
    if (isInfluencerShareContext && uuid) {
      navigate(`/advertiser/influencers/shared/${uuid}/social_posts`)
    } else if (isAdvertiserContext) {
      // Campaign share context - keep existing behavior or handle accordingly
      navigate(`/project_manager/authentications/${currentAuthentication.id}/influencer/social_posts`)
    } else {
      navigate(`/project_manager/authentications/${currentAuthentication.id}/influencer/social_posts`)
    }
  }

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode p-4 rounded-md">
      <div className="flex justify-between">
        <p className="font-bold text-xl mb-4 dark:text-white">Social posts</p>
        {!isAdvertiserContext && !isInfluencerShareContext && <button className="font-bold text-sm dark:text-white" onClick={() => navigate(`/project_manager/authentications/${currentAuthentication.id}/influencer/social_posts`)}>Go to social posts</button>}
        {isInfluencerShareContext && <button className="font-bold text-sm dark:text-white" onClick={handleGoToSocialPosts}>Go to social posts</button>}
      </div>
      <div className="flex flex-wrap gap-4">
        {posts.map(post => (
          <Post
            key={post.id}
            post={post}
            reach={currentAuthentication.reach}
            showViews={true}
          />
        ))}
      </div>
    </div>
  )
})